module.exports = __webpack_public_path__ + "img/bannerBg.7aa7c523.png";